var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_add_24px","d":"M19,13H13v6H11V13H5V11h6V5h2v6h6Z","transform":"translate(-5 -5)","fill":"#66a9f4"}));
}

Add.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Add;

Add.default = Add;
